export enum yesNo {
    yes = "yes",
    no = "no"
}